import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
import 'url-search-params-polyfill';
var UrlParamsHelper = /*#__PURE__*/function () {
  function UrlParamsHelper() {
    _classCallCheck(this, UrlParamsHelper);
    this.localStorageTimestampValidity = 1000 * 60 * 60 * 24;
  }
  /**
   * Save all Get-Parameters to local storage.
   */
  _createClass(UrlParamsHelper, [{
    key: "saveGetParamsToLocalStorage",
    value: function saveGetParamsToLocalStorage() {
      var urlParams = this.getUrlParams();
      if (urlParams !== null) {
        var storageData = this.getUrlParamsFromLocalStorage();
        if (typeof window !== 'undefined' && storageData === null) {
          localStorage.setItem('urlParams', JSON.stringify({
            params: urlParams,
            timestamp: new Date().getTime()
          }));
        }
      }
    }

    /**
     * Delete url params from local storage, if they are older than 24 hours.
     */
  }, {
    key: "cleanupUrlParams",
    value: function cleanupUrlParams() {
      var storageData = this.getUrlParamsFromLocalStorage();
      if (typeof window !== 'undefined' && storageData !== null) {
        if (this.isExpired(storageData.timestamp)) {
          localStorage.removeItem('urlParams');
        }
      }
    }

    /**
     * Check if timestamp is expired.
     * @param {*} timestamp
     */
  }, {
    key: "isExpired",
    value: function isExpired(timestamp) {
      return new Date().getTime() - timestamp > this.localStorageTimestampValidity;
    }

    /**
     * Create object from parameters string.
     * @param {*} entries
     */
  }, {
    key: "paramsToObject",
    value: function paramsToObject(entries) {
      var result = {};
      var _iterator = _createForOfIteratorHelper(entries),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var entry = _step.value;
          // each 'entry' is a [key, value] tupple
          result[entry[0]] = entry[1];
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return result;
    }

    /**
     * Read url params from location href
     */
  }, {
    key: "getUrlParams",
    value: function getUrlParams() {
      if (typeof window !== 'undefined') {
        var location = window.location.href;
        if (location.indexOf('?') !== -1) {
          var urlParts = location.split('?');
          var params = new URLSearchParams(urlParts[1]);
          var entries = params.entries(); //returns an iterator of decoded [key,value] tuples
          var paramsAsObject = this.paramsToObject(entries);
          return paramsAsObject;
        }
      }
      return null;
    }

    /**
     * Get url params from local storage (including timestamp)
     */
  }, {
    key: "getUrlParamsFromLocalStorage",
    value: function getUrlParamsFromLocalStorage() {
      if (typeof window !== 'undefined') {
        var storageData = localStorage.getItem('urlParams');
        if (storageData !== null) {
          storageData = JSON.parse(storageData);
          return storageData;
        }
      }
      return null;
    }

    /**
     * Get object with url params from local storage (params only, no timestamp)
     */
  }, {
    key: "getUrlParamsAsObjectForPayload",
    value: function getUrlParamsAsObjectForPayload() {
      var paramsFromStorage = this.getUrlParamsFromLocalStorage();
      if (paramsFromStorage !== null) {
        return paramsFromStorage.params;
      }
      return null;
    }
  }]);
  return UrlParamsHelper;
}();
export default UrlParamsHelper;